import { WwwcTool, ZoomTool, PanTool, BrowseSeriesTool } from "./builtIn";

const INPUT_EVENTS = {
  MOUSE_DOWN: 0x0, // 0 *
  MOUSE_DOWN_ACTIVATE: 0x1, // 1
  MOUSE_DOUBLE_CLICK: 0x2, // 2
  MOUSE_DRAG: 0x4, // 4
  MOUSE_MOVE: 0x8, // 8
  MOUSE_UP: 0x16 // 16
};

var BuiltInTool = [
  {
    name: "Contrast",
    eventType: "ContrastEvent",
    //"inputType" : INPUT_EVENTS.MOUSE_DRAG | INPUT_EVENTS.MOUSE_MOVE | INPUT_EVENTS.MOUSE_UP
    inputType: INPUT_EVENTS.MOUSE_DRAG | INPUT_EVENTS.MOUSE_UP,
    onMouseDrag: new WwwcTool().onMouseDrag,
    onMouseUp: new WwwcTool().onMouseUp
  },
  {
    name: "Zoom",
    eventType: "ZoomEvent",
    inputType: INPUT_EVENTS.MOUSE_DRAG | INPUT_EVENTS.MOUSE_UP,
    onMouseDrag: new ZoomTool().onMouseDrag,
    onMouseUp: new ZoomTool().onMouseUp
  },
  {
    name: "Pan",
    eventType: "PanEvent",
    inputType: INPUT_EVENTS.MOUSE_DRAG | INPUT_EVENTS.MOUSE_UP,
    onMouseDrag: new PanTool().onMouseDrag,
    onMouseUp: new PanTool().onMouseUp
  },
  {
    name: "BrowseSeries",
    eventType: "BrowseSeriesEvent",
    inputType: INPUT_EVENTS.MOUSE_DRAG,
    onMouseDrag: new BrowseSeriesTool().onMouseDrag
  }
];

export default BuiltInTool;
